import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import removerFiltroPontoEmbarque from '../../actions/pontoEmbarque/removerFiltroPontoEmbarque'

export class FiltrosAdicionadosPontosEmbarque extends Component {
  exibirFiltro (filtro) {
    if (filtro.valor && filtro.valor.valor) {
      return (
        <div key={`${filtro.chave}${filtro.valor.chave}`} className="col-xl-auto justify-content-md-center">
          <span id="badge-filtro" className="badge badge-secondary badge-filtro">
            {filtro.label} = {filtro.valor.valor}
            <span id="btn-remover-filtro" className="badge badge-light ml-2 clicavel"
              onClick={() => this.props.removerFiltroPontoEmbarque(filtro)}>&times;
            </span>
          </span>
        </div>
      )
    }
    return (
      <div key={`${filtro.chave}${filtro.valor}`} className="col-xl-auto justify-content-md-center">
        <span id="badge-filtro" className="badge badge-secondary badge-filtro">
          {filtro.label} = {filtro.valor}
          <span className="badge badge-light ml-2 clicavel"
            onClick={() => this.props.removerFiltroPontoEmbarque(filtro)}>&times;
          </span>
        </span>
      </div>
    )
  }

  render () {
    return (this.props.filtrosAdicionadosPontoEmbarque || []).map(filtro => this.exibirFiltro(filtro))
  }
}

const mapStateToProps = ({ filtrosAdicionadosPontoEmbarque }) => ({ filtrosAdicionadosPontoEmbarque })

const mapDispatchToProps = dispatch => bindActionCreators({
  removerFiltroPontoEmbarque
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FiltrosAdicionadosPontosEmbarque)
